import validacionObjetos from './ServicioObjetos';
import { X509, KJUR, zulutodate, KEYUTIL } from 'jsrsasign';
export const FIEL = "FIEL";
export const CSD = "CSD";
const VALOR_VERIFICACION_FIRMA = "cadena de verificacion";
export function validacionCertificadosDigitales(contenidoArchivoCer, contenidoArchivoKey,
    contrasenaKey, rfcEmisor, typoCertificado) {

    if (validacionObjetos.esObjetoVacio(contenidoArchivoCer))
        throw new Error("El contenido del archivo .cer no debe de ser vacio");
    if (validacionObjetos.esObjetoVacio(contenidoArchivoKey))
        throw new Error("El contenido del archivo .key no debe de ser vacio");
    if (validacionObjetos.esObjetoVacio(contrasenaKey))
        throw new Error("La contraseña de los certificados no debe de ser vacia");
    if (validacionObjetos.esObjetoVacio(rfcEmisor))
        throw new Error("El rfc de emisor no debe de ser vacio");
    if (validacionObjetos.esObjetoVacio(typoCertificado))
        throw new Error( "El atributo tipo certificado no debe de ser vacio");

    if (typoCertificado !== FIEL && typoCertificado !== CSD)
        throw new Error("El Atributo tipo certificado debe de ser FIEL o CSD");

    let certificadoX509 = obtenerCertificadoX505(contenidoArchivoCer);
    let llavePrivada = obtenerLlavePrivada(contenidoArchivoKey, contrasenaKey);
    validaCorrespondenciasLLavePrivadaConPublica(llavePrivada, certificadoX509.getPublicKey());
    let subject = certificadoX509.getSubjectString();    
    if (!subject.includes(rfcEmisor))
        throw new Error("El certificado que intenta validar no corresponde al rfc de emisor");

    if (typoCertificado === CSD) {
        if (!subject.includes("OU="))
            throw new Error("El certificado (.cer) no es de tipo CSD");
    } else {
        if (subject.includes("OU="))
            throw new Error("El certificado (.cer) no es de tipo FIEL");
    }

    let ahora = new Date();
    let idsenube = zulutodate(certificadoX509.getNotBefore());
    var fin = zulutodate(certificadoX509.getNotAfter());

    if ((idsenube > ahora))
        throw new Error("Archivo (.cer) revocado o caduco");
    if ((fin < ahora))
        throw new Error("Archivo (.cer) revocado o caduco");

    let numeroCertificado = byteArrayString(stringBigIntAByteArray(certificadoX509.getSerialNumberHex()));
    return { fechaInicial: idsenube, fechaFinal: fin, numeroCertificado: numeroCertificado };

}

function obtenerLlavePrivada(contenidoArchivoKey, contrasenaKey) {
    var llavePrivada = null;
    try {
        let pkcs8PEM = "" +
            "-----BEGIN ENCRYPTED PRIVATE KEY-----\r\n" +
            contenidoArchivoKey +
            "-----END ENCRYPTED PRIVATE KEY-----\r\n";
        llavePrivada = KEYUTIL.getKey(pkcs8PEM, contrasenaKey);
    } catch (error) {
        throw new Error("El contenido del archivo .key está dañado, tiene un formáto inválido o la contraseña no corresponde a la llave privada");
    }
    return llavePrivada;
}

function obtenerCertificadoX505(contenidoArchivoCer) {
    let certificadoX509 = null;
    try {
        let z1CertPEM = "" +
            "-----BEGIN CERTIFICATE-----\n" +
            contenidoArchivoCer +
            "\n-----END CERTIFICATE-----";
        certificadoX509 = new X509();
        certificadoX509.readCertPEM(z1CertPEM);
    } catch (error) {
        console.log();
        throw new Error("El archivo .cer esta dañado o tiene un formáto inválido");
    }
    return certificadoX509;
}

function validaCorrespondenciasLLavePrivadaConPublica(llavePrivada,
    llavePublica) {
    try {
        var firmador = new KJUR.crypto.Signature({ "alg": "SHA1withRSA" });
        firmador.init(llavePrivada);
        firmador.updateString(VALOR_VERIFICACION_FIRMA);
        var firmaElectronica = firmador.sign();

        var verificador = new KJUR.crypto.Signature({ "alg": "SHA1withRSA" });
        verificador.init(llavePublica);
        verificador.updateString(VALOR_VERIFICACION_FIRMA);
        var verificacion = verificador.verify(firmaElectronica);
        if (!verificacion)
            throw new Error("La llave privada no corresponde a la llave pública");
    } catch (error) {
        throw new Error("La llave privada no corresponde a la llave pública");
    }
}

function stringBigIntAByteArray(cadena) {
    var hexString = cadena.toString(16);
    if (hexString.length % 2 > 0) hexString = "0" + hexString;
    var byteArray = [];
    for (var i = 0; i < hexString.length; i += 2) {
        byteArray.push(parseInt(hexString.slice(i, i + 2), 16));
    }
    return byteArray;
}

function byteArrayString(arreglo) {
    var resultado = "";
    for (var i = 0; i < arreglo.length; ++i) {
        resultado += (String.fromCharCode(arreglo[i]));
    }
    return resultado;
}

export function validacionArchivoReq(elContenidoArchivoReq, rfcContribuyente) {
    if (!validacionObjetos.esObjetoVacio(elContenidoArchivoReq)){
        //throw new Error("El contenido del archivo .req no debe de ser vacio");

        var contenidoArchivoReq = atob(elContenidoArchivoReq);
        contenidoArchivoReq = contenidoArchivoReq.replace(/[^ -~]+/g, "")
        if (!contenidoArchivoReq.includes(rfcContribuyente))
            throw new Error("El archivo .req que intenta validar no corresponde al rfc de emisor");
    }       
}